export default () => {
  const button = document.querySelector( '.header-desktop-contact-btn' );
  if ( ! button ) {
    return;
  }

  let target = null;

  const closeButton = document.querySelector( '.header-desktop-contact-btn-close' );
  closeButton.addEventListener( 'click', ( e ) => {
    e.preventDefault();

    target.classList.toggle( 'hide' );
  } );

  button.addEventListener( 'click', ( e ) => {
    e.preventDefault();

    const targteLink = button.getAttribute( 'href' );
    target = document.querySelector( targteLink );

    if ( target ) {
      target.classList.toggle( 'hide' );
    }
  } );
}
